module.exports = "<div *ngIf=\"topbar.searching\" class=\"border-bottom white-bg dashboard-header\">\n  <div *ngFor=\"let service of type\">\n    <h3>{{service.name}}</h3>\n    <div *ngFor=\"let data of service.data\">\n      <a (click)=\"topbar.setTerm('')\" [routerLink]=\"data.searchLink\">{{data.name}}</a>\n    </div>\n    <span *ngIf=\"service.data.length === 0\">\n      {{ 'common.no_result' | translate }}\n    </span>\n    <hr/>\n  </div>\n  <h4 *ngIf=\"type?.length == 0\">{{ 'common.loading' | translate }}</h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search/search.component.html
// module id = ./src/app/modules/search/search.component.html
// module chunks = main